import {
  AvailableAppsResponse,
  DeviceDetailResponse,
  isUser,
} from 'repositories/device/responseType';
import {
  AvailableApplication,
  AvailableApps,
  AvailableDistribution,
  Device,
} from 'models/Device/type';
import { DeviceFamilyType, OwnerType } from 'models/Device/enum';

export const getDeviceFamilyType = (familyType: number): DeviceFamilyType => {
  switch (familyType) {
    case 0:
      return DeviceFamilyType.iphone;
    case 1:
      return DeviceFamilyType.ipad;
    case 2:
      return DeviceFamilyType.universal;
    default:
      return DeviceFamilyType.unSupported;
  }
};

export const convertToDevice = (
  uid: string,
  response: DeviceDetailResponse
): Device => {
  return {
    uid,
    detail: {
      osVersion: response.results.device_os_version,
      deviceFamily: getDeviceFamilyType(response.results.iphone_device_family),
      deviceName: response.results.device_name,
      enterpriseProvisioningWarningAppears:
        response.results.is_greater_or_equal_to_9,
      updateProfileWarningAppears: response.results.is_desktop_mode,
      mustOverwriteInstall: response.results.show_ios_8_guide_after_install,
      overwriteInstallAvailable: response.results.show_overwrite_install_link,
    },
    email: response.results.email,
  };
};

export const convertToAvailableApps = (
  response: AvailableAppsResponse
): AvailableApps => {
  const applications = response.results.my_apps.map(
    (app): AvailableApplication => {
      return {
        ownerName: app.user.name,
        ownerType: isUser(app.user) ? OwnerType.user : OwnerType.organization,
        bundleIdentifier: app.package_name,
        revision: app.revision,
        iconSrc: app.icon,
        title: app.name,
        version: `${app.version_name} (${app.version_code})`,
        versionName: app.version_name,
        releaseNote: app.message,
        updatedDate: new Date(app.updated_at * 1000),
        visible: true,
      };
    }
  );

  const distributions = response.results.distributions.map(
    (distribution): AvailableDistribution => {
      return {
        accessKey: distribution.access_key,
        ownerName: distribution.application.user.name,
        revision: distribution.application.revision,
        iconSrc: distribution.application.icon,
        applicationName: distribution.application.name,
        applicationBundleIdentifier: distribution.application.package_name,
        version: `${distribution.application.version_name} (${distribution.application.version_code})`,
        title: distribution.title,
        updatedDate: new Date(distribution.updated_at * 1000),
      };
    }
  );

  return {
    applications,
    distributions,
  };
};
